import React, { useState } from 'react';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import { UserResource } from '~~apis/resource';
import { useQuery } from '~~utils/CommonUtils';
import IconPassword from './assets/IconPassword.svg';
import IconPasswordConfirm from './assets/IconPasswordConfirm.svg';
import { StyledForm } from './Styles';
import { STATUS } from './LoginConsts';

const ResetPasswordForm = () => {
  const query = useQuery();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [apiStatus, setApiStatus] = useState('');
  const email = query.get('email');
  const token = query.get('token');

  function handleSubmit(e) {
    e.preventDefault();
    setApiStatus('LOADING');

    if (password !== passwordConfirm) {
      return handleError('PASSWORD_CONFIRM_NOT_EQUAL');
    }

    UserResource.resetPassword({ email, token, password })
      .then(() => {
        setApiStatus('SUCCESS');
      })
      .catch((error) => {
        return handleError(error.message);
      });
  }

  function handlePasswordOnchange(e) {
    if (errorMsg) {
      setErrorMsg('');
    }

    setPassword(e.target.value);
  }

  function handlePasswordConfirmOnchange(e) {
    if (errorMsg) {
      setErrorMsg('');
    }

    setPasswordConfirm(e.target.value);
  }

  function handleKeyPress(e) {
    if ('Enter' !== e.key) {
      return;
    }

    e.preventDefault();
    if (handleCheckDisabled()) {
      return;
    }

    return handleSubmit(e);
  }

  function handleError(errorCode) {
    const status = 'ERROR';
    setApiStatus(status);
    let errorMessage = '發生錯誤，請稍後再試，或與我們聯絡。';
    switch (errorCode) {
      case 'PASSWORD_CONFIRM_NOT_EQUAL':
        errorMessage = '確認密碼與密碼不相符';
        break;
      case 'INVALID_TOKEN':
        errorMessage = '密碼重設連結已失效，如有需要請重新申請';
        break;
      case 'INVALID_PASSWORD_FORMAT':
        errorMessage = '密碼需超過五碼並包含至少一個英文及一個數字';
        break;
      case 'TOKEN_DECODE_ERROR':
        errorMessage = '密碼重設金鑰錯誤，請提供截圖與連結並聯絡我們';
        break;
      case 'JSON_DECODE_ERROR':
        errorMessage = '重設格式錯誤，請提供截圖與連結並聯絡我們';
        break;
      case 'INVALID_EMAIL':
        errorMessage = '信箱與密碼重設連結不相符，請提供截圖與連結並聯絡我們';
        break;
      case 'INVALID_FORMAT':
        errorMessage = '格式錯誤，請提供截圖與連結並聯絡我們';
        break;
      default:
        break;
    }
    setErrorMsg(errorMessage);
  }

  function handleCheckDisabled() {
    return !password || !passwordConfirm || apiStatus === 'LOADING' || apiStatus === 'SUCCESS';
  }

  return (
    <StyledForm onSubmit={(e) => handleSubmit(e)} autoComplete="off" status={STATUS.SIGN_IN}>
      <div className="upper-box">Hi {email}，請輸入新密碼進行重設</div>
      <div className="bottom-box">
        {/* 密碼 */}
        <div className="input-field">
          <img src={IconPassword} alt="Password" />
          <Input
            placeholder="新密碼"
            name="password"
            type="password"
            onChange={handlePasswordOnchange}
            onKeyPress={handleKeyPress}
            value={password}
          />
        </div>
        {/* 確認密碼 */}
        <div className="input-field">
          <img src={IconPasswordConfirm} alt="PasswordConfirm" />
          <Input
            placeholder="確認新密碼"
            name="passwordConfirm"
            type="password"
            onChange={handlePasswordConfirmOnchange}
            onKeyPress={handleKeyPress}
            value={passwordConfirm}
          />
        </div>
        <div className="error-msg">{errorMsg && errorMsg}</div>
        <Button boxShadow round width="50%" type="submit" disabled={handleCheckDisabled()}>
          送出
        </Button>
        {apiStatus === 'SUCCESS' && <div className="normal-msg">完成密碼重設！請重新登入</div>}
      </div>
    </StyledForm>
  );
};

export default ResetPasswordForm;
